<!--<app-header-one [hidden]="true" (resultSearch)="filter($event)"  [sticky]="true"></app-header-one>-->
<app-header-four (resultSearch)="filter($event)" [sticky]="true"></app-header-four>

<!-- Home slider start-->
<section #boxSearch class="p-0 height-85 tools_slider">
    <owl-carousel-o [options]="HomeSliderConfig" class="home-slider">
        <ng-container *ngFor="let item of homeSlider">
            <ng-template carouselSlide>
                <img [src]="item.url" class="img-fluid" alt="">
            </ng-template>
        </ng-container>
    </owl-carousel-o>
</section>
<!-- Home slider End -->

<!-- about section start-->
<section>
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-2">
                <div class="title3">
                    <h2 class="title-inner3" [textContent]="titleWelcome"></h2>
                    <div class="line"></div>
                </div>
                <div class="about-text">
                    <p [textContent]="messageWelcome"></p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- about section end-->

<!-- search section start-->
<!--<div *ngIf="userSearch" class="title1 title-gradient section-t-space">
    <h2 class="title-inner1">Resultados</h2>
</div>
<section class="p-t-0 section-b-space gym-product">
    <div *ngIf="userSearch" class="container">
        <div class="row partition-cls">
            <div class="col-xl-3 col-sm-6 d-grid my-2" *ngFor="let product of resultSearch">
                <div class="product-box d-grid align-content-center">
                    <app-product-box-one
                            [product]="product"
                            [loader]="true"
                            [currency]="productService?.Currency"
                            [cartModal]="true">
                    </app-product-box-one>
                </div>
            </div>
            <div class="col-sm-12 text-center section-b-space mt-5 no-found" *ngIf="!resultSearch.length">
                <img src="assets/images/empty-search.jpg" class="img-fluid mb-4">
                <h3>¡Lo sentimos! No se ha encontrado el producto que buscaba. </h3>
                <a [routerLink]="['/products']" class="btn btn-solid">seguir comprando</a>
            </div>
        </div>
    </div>
</section>-->
<!-- search section end-->

<!-- category -->
<section class="pt-0 category-tools">
    <div class="container">
        <div class="row">
            <div class="col">
                <app-collection [class]="'pt-0'" [categories]="categories" [category]="'tools'">
                </app-collection>
            </div>
        </div>
    </div>
</section>
<!-- category end -->

<!--<button [hidden]="true" (click)="updateCategories()" class="btn" >-->
<!--    click-->
<!--</button>-->
<!--<button [hidden]="true" (click)="getProducts()" class="btn btn-solid" >-->
<!--    get products-->
<!--</button>-->
<!--<a class="btn" href="chrome://www.google.com">Abrir en Google Chrome</a>-->


<!-- parallax section start -->
<section class="full-banner parallax-banner21 parallax small-slider tools-parallax-product"
    [ngStyle]="{'background-image': 'url('+ bannerParallax +')'}">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-12 tools-grey">
                <owl-carousel-o [options]="ProductSliderConfig" class="tools-product-4 product-m">
                    <ng-container *ngFor="let product of products2">
                        <ng-template carouselSlide>
                            <div class="product-box product-wrap d-grid">
                                <app-product-box-three [product]="product" [currency]="productService?.Currency">
                                </app-product-box-three>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </div>
        </div>
    </div>
</section>
<!-- parallax section end -->

<!-- product slider start -->
<section class="section-b-space tools-grey">
    <div class="container">
        <div class="row">
            <div class="col">
                <div class="title3">
                    <h2 class="title-inner3">Productos Destacados</h2>
                    <div class="line"></div>
                </div>
                <owl-carousel-o [options]="ProductSliderConfig" class="product-5 product-m no-arrow">
                    <ng-container *ngFor="let product of products">
                        <ng-template carouselSlide>
                            <div class="product-box product-wrap d-grid">
                                <app-product-box-three [product]="product" [currency]="productService?.Currency">
                                </app-product-box-three>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </div>
        </div>
    </div>
</section>
<!-- product slider end -->

<!-- product slider start -->
<section class="section-b-space tools-grey">
    <div class="container">
        <div class="row">
            <div class="col">
                <div class="title3">
                    <h2 class="title-inner3">Nuevos productos</h2>
                    <div class="line"></div>
                </div>
                <owl-carousel-o [options]="ProductSliderConfig" class="product-5 product-m no-arrow">
                    <ng-container *ngFor="let product of newProducts">
                        <ng-template carouselSlide>
                            <div class="product-box product-wrap d-grid">
                                <app-product-box-three [product]="product" [currency]="productService?.Currency">
                                </app-product-box-three>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </div>
        </div>
    </div>
</section>
<!-- product slider end -->

<!-- Newsletters slider start -->
<section class="section-b-space tools-grey" *ngIf="newsLetters && newsLetters.length > 0">
    <div class="container">
        <div class="row">
            <div class="col">
                <div class="title3">
                    <h2 class="title-inner3">Noticias</h2>
                    <div class="line"></div>
                </div>
                <owl-carousel-o [options]="ProductSliderConfig" class="product-5 product-m no-arrow">
                    <ng-container *ngFor="let news of newsLetters">
                        <ng-template carouselSlide>
                            <div class="product-box product-wrap d-grid">
                                <!-- <app-product-box-three [product]="product" [currency]="productService?.Currency">
                                </app-product-box-three> -->
                                <div class="img-wrapper">
                                    <div class="w-100 front d-flex justify-content-center">
                                        <a>
                                            <img [defaultImage]="'assets/images/product/placeholder.jpg'"
                                                [lazyLoad]="news.newsletter_imagesm" class="img-fluid img-home"
                                                alt="{{ news.newsletter_name }}" style="height: 21vh; object-fit:contain;">
                                        </a>
                                    </div>
                                    <div class="cart-box">
                                        <a href="javascript:void(0)" (click)="NewsLetterModal(news)"
                                            title="NewsLetters">
                                            <i class="ti-info" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="product-info my-3">
                                    <a>
                                        <h6>{{ news?.newsletter_name | titlecase }}</h6>
                                    </a>
                                    <h4>
                                        {{timeConverter(news.newsletter_date)}}
                                    </h4>
                                </div>
                            </div>
                        </ng-template>
                    </ng-container>
                </owl-carousel-o>
            </div>
        </div>
    </div>
</section>
<!-- Newsletters slider end -->

<!-- product section start -->
<!--<section [hidden]="true" class="section-b-space tools_product">-->
<!--    <div class="container">-->
<!--        <div class="row multiple-slider">-->
<!--            <div class="col-xl-12 col-lg-12 col-md-12">-->
<!--                <app-product-box-vertical-slider [title]="'new products'" [type]="'tools'">-->
<!--                </app-product-box-vertical-slider>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</section>-->
<!-- product section end -->

<!--  logo section start-->
<!--<section [hidden]="true" class="section-b-space tools-brand">-->
<!--    <div class="container">-->
<!--        <div class="row">-->
<!--            <div class="col-md-12">-->
<!--                <app-logo [logos]="logos"></app-logo>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</section>-->
<!--  logo section End-->

<!-- Cart Open To Top Side-->
<app-cart-variation [direction]="'top'"></app-cart-variation>
<app-footer-one [class]="'sticky-footer'" [newsletter]="false" [themeLogo]="themeLogo"></app-footer-one>

<!--modal popup start-->
<ng-template class="theme-modal" #newsletter let-modal>
    <div class="modal-content">
        <div class="modal-body">
            <div class="container-fluid p-0">
                <div class="row">
                    <div class="col-12">
                        <div class="modal-bg">
                            <button type="button" class="close float-end border-0 mb-2" aria-label="Close"
                                (click)="modal.dismiss('Cross click')">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="offer-content">
                                <div class="w-100 front d-flex justify-content-center">
                                    <img [defaultImage]="'assets/images/product/placeholder.jpg'" style="width: 100%;"
                                        [lazyLoad]="dataNewsLetter?.newsletter_imagesm" class="w-100 img-fluid img-home"
                                        alt="{{ dataNewsLetter?.newsletter_name }}" class="img-fluid" alt="">
                                </div>
                                <div class="m-4">
                                    <h2 class="text-center">{{dataNewsLetter?.newsletter_name}}</h2>
                                    <h6>
                                        {{timeConverter(dataNewsLetter?.newsletter_date)}}
                                    </h6>
                                    <h4 class="mt-2" [innerHTML]="dataNewsLetter?.newsletter_description">
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<!--modal popup end-->